import { Directive, Input } from '@angular/core';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form';

@Directive()
export abstract class BaseICCDFormComponent<T extends { [key: string]: any; }> extends BaseCtrlValueAccessorFormComponent<T> {
  @Input() context?: { TSK: 'OA' | 'F' | 'D' | 'S' | 'MI' };
}
